import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ColorName } from '@panaya/ui/styles-to-code';
import { kebabToPascalCase, DefaultTo, DefaultToProperty } from '@panaya/utils';
import { allIcons as featherIcons } from 'angular-feather/icons';
import { DefaultIconColor, DefaultIconSize } from '../defaults';
import { IconName, IconSize } from '../types';

@Component({
    selector: 'p-icon',
    templateUrl: './p-icon.component.html',
    styleUrls: ['./p-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'pIcon'
})
export class PIconComponent implements OnChanges {
    // TODO(Angular 16+): Use required inputs and remove the ! sign
    @Input() public name!: IconName;
    @Input() @DefaultTo(DefaultIconSize) public size!: IconSize;
    @Input() @DefaultTo(DefaultIconColor) public color!: ColorName;
    @Input() @DefaultTo(false) public disabled!: boolean;
    // Pseudo state inputs
    @Input() @DefaultToProperty('color') public hoverColor!: ColorName;
    @Input() @DefaultToProperty('color') public focusColor!: ColorName;

    private _isFeatherIcon = false;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['name']) {
            this._isFeatherIcon = kebabToPascalCase(changes['name'].currentValue) in featherIcons;
        }
    }

    public get isFeatherIcon(): boolean {
        return this._isFeatherIcon;
    }

    public get isSvgIcon(): boolean {
        return !this.isFeatherIcon;
    }
}
